export class Document {
    constructor(
        public blobFileName: string,
        public blobId: number,
        public prefix: string
    ) {}

    getDocName() {
        return this.prefix + this.blobFileName;
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/shared/download/document.model.ts